/* Coloring Bru — small interactions (menu, club unlock) */
(function () {
  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  /* Slim menu under the logo: opens on click */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cb-menu-btn]');
    if (!btn) return;
    var nav = document.getElementById(btn.getAttribute('aria-controls'));
    if (!nav) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    nav.classList.toggle('is-open', open);
  });

  /* The club: locked until someone joins */
  function capitalize(name) {
    name = (name || '').trim();
    return name ? name.charAt(0).toUpperCase() + name.slice(1) : '';
  }

  function unlock(club) {
    club.classList.add('is-member');
    var data = {};
    try { data = JSON.parse(store('cbClub') || '{}'); } catch (e) { data = {}; }
    var first = data.first || club.getAttribute('data-fallback-name') || 'friend';
    club.querySelectorAll('[data-cb-first]').forEach(function (el) { el.textContent = first; });
    if (data.hex) {
      club.style.setProperty('--fav', data.hex);
      club.style.setProperty('--fav-ink', data.dark ? '#FFFFFF' : '#2E2A3F');
    }
    club.querySelectorAll('[data-cb-color-name]').forEach(function (el) { el.textContent = data.color || 'Cornflower'; });
  }

  /* Shopify sometimes shows an "I'm not a robot" page after the club form.
     When the visitor comes back from it (to any page), remember they joined
     and take them straight back to the unlocked club. */
  function pending(value) {
    try {
      if (value === undefined) {
        var raw = window.localStorage.getItem('cbClubPending');
        if (!raw) return null;
        var item = JSON.parse(raw);
        if (!item || Date.now() - item.at > 10 * 60 * 1000) { window.localStorage.removeItem('cbClubPending'); return null; }
        return item.path;
      }
      if (value === null) window.localStorage.removeItem('cbClubPending');
      else window.localStorage.setItem('cbClubPending', JSON.stringify({ path: value, at: Date.now() }));
    } catch (e) { return null; }
  }
  (function returnToClub() {
    var path = pending();
    if (!path) return;
    pending(null);
    store('cbClubMember', '1');
    if (window.location.pathname !== path) window.location.replace(path + '?customer_posted=true');
  })();

  function initClub(club) {
    var posted = /[?&]customer_posted=true/.test(window.location.search) || !!club.querySelector('[data-cb-posted]');
    var hasErrors = club.querySelector('[data-cb-form-errors]');
    if (hasErrors) { try { window.localStorage.removeItem('cbClubMember'); } catch (e) {} }
    if (posted && !hasErrors) store('cbClubMember', '1');
    if (store('cbClubMember') === '1' && !hasErrors) unlock(club);

    var form = club.querySelector('.cb-club-form');
    if (!form) return;

    var back = document.createElement('input');
    back.type = 'hidden';
    back.name = 'return_to';
    back.value = window.location.pathname;
    form.appendChild(back);

    var note = document.createElement('p');
    note.className = 'cb-club-note';
    note.setAttribute('role', 'alert');
    note.hidden = true;
    note.style.cssText = 'margin:0;padding:8px 14px;border-radius:999px;background:#F9D3E0;color:#B23A6B;font-size:13.5px;text-align:center;';
    var swatches = form.querySelector('.cb-swatches');
    if (swatches) swatches.insertAdjacentElement('afterend', note);

    form.addEventListener('invalid', function (event) {
      var field = event.target;
      if (field.name === 'cb_color') event.preventDefault();
      if (note.getAttribute('data-busy')) return;
      note.setAttribute('data-busy', '1');
      setTimeout(function () { note.removeAttribute('data-busy'); }, 50);
      if (field.name === 'cb_color') {
        note.textContent = 'Pick your favorite color first!';
      } else if (field.name === 'contact[email]') {
        note.textContent = field.value ? 'Hmm, that email doesn’t look quite right.' : 'Bru needs your email to send the club goodies.';
      } else {
        note.textContent = 'Bru needs your first name, please!';
      }
      note.hidden = false;
    }, true);
    form.addEventListener('change', function () { note.hidden = true; });

    form.addEventListener('submit', function () {
      pending(window.location.pathname);
      store('cbClubMember', '1');
      var firstInput = form.querySelector('[name="contact[first_name]"]');
      var picked = form.querySelector('input[name="cb_color"]:checked');
      var first = capitalize(firstInput ? firstInput.value : '');
      if (firstInput) firstInput.value = first;
      var color = picked ? picked.getAttribute('value') : '';
      var tags = form.querySelector('[data-cb-tags]');
      if (tags) {
        var base = tags.getAttribute('data-base') || 'club';
        tags.value = color ? base + ', fav-color-' + color.toLowerCase().replace(/\s+/g, '-') : base;
      }
      store('cbClub', JSON.stringify({
        first: first,
        color: color,
        hex: picked ? picked.getAttribute('data-hex') : '',
        dark: picked ? picked.getAttribute('data-dark') === 'true' : false
      }));
    });
  }

  function ready() {
    document.querySelectorAll('[data-cb-club]').forEach(initClub);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
